<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="tab1" :onclick="reset" href="/tabs/tab1">
          <ion-icon :icon="paperPlane" />
          <ion-label>掛號</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="PatientSearch" :onclick="reset" href="/tabs/search">
          <ion-icon :icon="searchOutline" />
          <ion-label>查詢</ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="tab2" :onclick="reset" href="/tabs/tab2">
          <ion-icon :icon="searchOutline" />
          <ion-label>查詢</ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="tab3" :onclick="reset" href="/tabs/tab3">
          <ion-icon :icon="medkit" />
          <ion-label>門診</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab4" :onclick="reset" href="/tabs/tab4">
          <ion-icon :icon="person" />
          <ion-label>帳戶</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { defineComponent,inject,toRefs } from 'vue';
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue';
import { medkit,searchOutline, person, paperPlane } from 'ionicons/icons';

export default defineComponent({
  name: 'TabsPage',
  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonPage, IonRouterOutlet },
  setup() {
    const mapStore = inject("mapStore");
    const { state } = mapStore;
    function reset(){
      state.operation = '';
    }
    return {
      searchOutline, 
      person, 
      paperPlane,
      medkit,
      reset,
      ...toRefs(state)
    }
  }
});
</script>
<style scoped>
ion-icon{
  font-size: 1.4rem;
}
ion-tab-bar{
  padding-top: 8px;
  border: 1px solid;
  border-color: #e8e8e8;
  border-radius: 15px 15px 0 0;
  box-shadow: rgb(0 0 0 / 12%) 0px 4px 16px;
  overflow: hidden;
  background-color: #fff;
}
ion-tab-button{
  transform: translateY(-5%);
  background-color: #fff;
}
ion-tab-button:hover{
  background-color: #fff;
  animation:tap 1s;
}
@keyframes tap {
  from{
    border-radius: 20px;
    background-color: #c4c4c4;
  }
  to{
    border-radius: 0px;
    background-color: #fff;
  }
}
</style>
